import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import Vue from 'vue'
import Router from 'vue-router'
import store from "../vuex/store.js";
import Cookies from "js-cookie";

// Admin pages
import Overview from 'src/pages/Overview/Overview.vue'

//AUTH
import Register from 'src/pages/Auth/Register.vue'
import Recover from 'src/pages/Auth/Recover.vue'
import Login from 'src/pages/Auth/Login.vue'
import About from 'src/pages/Auth/About.vue'

//PROFILE
import Profile from 'src/pages/Profile/Edit.vue'

//Platform VIEW
import Platform from 'src/pages/Platform/View.vue'

//POSTULATION
import Postulation from 'src/pages/Postulation/List.vue'

//MY PAYMENTS
import MyPayments from 'src/pages/MyPayments/List.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login
      },
    ]
  },
   
  {
    path: '/recover',
    component: Recover,
    children: [
      {
        path: '/recover',
        name: 'recover',
        component: Recover
      },
     
      
    ]
  },
  {
    path: '/registro',
    component: Register,
    children: [
      {
        path: '/registro',
        name: 'register',
        component: Register
      },

      
    ]
  },
  {
    path: '/about',
    component: About,
    children: [
      {
        path: '/about',
        name: 'about',
        component: About
      },
  
    ]
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'platform/:id',
        name: 'Platform',
        component: Platform
      },
      {
        path: 'postulation',
        name: 'Postulation',
        component: Postulation
      },
      {
        path: 'my-payments',
        name: 'MyPayments',
        component: MyPayments
      },

    ]
  },
  { path: '*', component: NotFound }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const accessToken = Cookies.get("access_token");

  if (accessToken) {
    console.log("entro")
    console.log(to.name)
    if (to.name === "overview") {
      next("/overview");
      return;
    } else if (to.name === 'login') {
      next("/overview");
      return;
    } else if (to.name === 'recover') {
      next("/overview");
      return;
    } else if (to.name === 'register') {
      next("/overview");
      return;
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    const isLoggedIn = store.state.status;

    if (requiresAuth && !isLoggedIn) {
      alert('Por favor inicie sesión para continuar');
      next("/login");
      return;
    }

    } else if (to.name !== 'login' && to.name !== 'recover' && to.name !== 'register' && to.name !== 'about') {
      console.log("redirecciona a login", to)
      
      next("/login");
      return;
    } 
    console.log("no necesita login", to)
    next();
});

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router
